import { useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";

import LoginPop from "../popUp/LoginPop";
import RegisterPop from "../popUp/RegisterPop";
import ForgetPop from "../popUp/ForgetPop";
import EditProfilePop from "../popUp/EditProfilePop";

const AllPopups = ({ userProfile = null, getDataOfUser = null }) => {
  const {
    showLogin,
    setShowLogin,
    showRegister,
    setShowRegister,
    showForget,
    setShowForget,
    showEditProfile,
    setShowEditProfile,
  } = useContext(AppContext);

  const closeAllPopups = () => {
    setShowLogin(false);
    setShowRegister(false);
    setShowForget(false);
    setShowEditProfile(false);
  };

useEffect(() => {
  console.log('===========!=========================');
  console.log(userProfile);
  console.log('====================================');
}, [userProfile]);

  return (
    <>
      {showLogin && (
        <LoginPop
          onClose={closeAllPopups}
          onSwitchToRegister={() => {
            setShowLogin(false);
            setShowRegister(true);
          }}
          onSwitchToForget={() => {
            setShowLogin(false);
            setShowForget(true);
          }}
        />
      )}

      {showRegister && (
        <RegisterPop
          onClose={closeAllPopups}
          onSwitchToLogin={() => {
            setShowRegister(false);
            setShowLogin(true);
          }}
        />
      )}

      {showForget && (
        <ForgetPop
          onClose={closeAllPopups}
          onSwitchToLogin={() => {
            setShowForget(false);
            setShowLogin(true);
          }}
        />
      )}

      {/* يظهر EditProfilePop فقط لو موجود userProfile */}
      {showEditProfile && userProfile && (
        <EditProfilePop
          onClose={closeAllPopups}
          userProfile={userProfile}
          onSave={getDataOfUser}
        />
      )}

    </>
  );
};

export default AllPopups;
